module.exports = __webpack_public_path__ + "static/media/stocks_banner.0376b141.svg";